import { connect } from "@transformd-ltd/sdk";
import React, { useEffect, useState } from "react";
import {
  NEXT_PAGE_IN_FLOW,
  PAGE_IDS_TO_REDIRECT_ON_CLICK_PREV,
} from "./constants";
import { computeNextPageId, getSelectedPageIds } from "./utils";

const NavigationController = ({
  getData,
  channel = "Initial",
  currentPage,
}) => {
  const [routeState, setRouteState] = useState({
    shouldRedirect: false,
    pageIdToRedirectTo: "",
  });

  // Workaround for handling the forced redirects
  // as navigateToPage() does not work correctly in PrevPage or NextPage emitters
  useEffect(() => {
    if (!channel || !currentPage[channel]) return;
    const currentPageId = currentPage[channel].pageId;

    const { shouldRedirect, pageIdToRedirectTo } = routeState;
    if (!shouldRedirect) return;

    // Reset state if redirect page is reached
    if (shouldRedirect && currentPageId === pageIdToRedirectTo) {
      setRouteState({
        shouldRedirect: false,
        pageIdToRedirectTo: "",
      });
      return;
    }

    // Proceed with redirect
    navigateToPage(pageIdToRedirectTo);
  }, [currentPage]);

  const data = getData();
  const emitter = data.getEmitter();

  emitter.on("NextPage", function(event) {
    const { oldPage } = event || {};

    // Get selected product data
    var affectedProducts = data.getFieldValue("affectedProducts");
    if (!Array.isArray(affectedProducts)) affectedProducts = [];

    var selectedPageIds = getSelectedPageIds(affectedProducts);

    // Only apply forced redirects for defined page IDs
    if (NEXT_PAGE_IN_FLOW[oldPage]) {
      // Compute the ID for the next page in the flow
      var nextPageId = computeNextPageId(oldPage, selectedPageIds);
      setRouteState({
        shouldRedirect: true,
        pageIdToRedirectTo: nextPageId,
      });
    }
  });

  emitter.on("PrevPage", function(event) {
    const { oldPage } = event || {};
    if (PAGE_IDS_TO_REDIRECT_ON_CLICK_PREV.includes(oldPage))
      setRouteState({
        shouldRedirect: true,
        pageIdToRedirectTo: "606250504f1a60000c2eae26",
      });
  });

  const navigateToPage = (id) => {
    data.store.dispatch({
      type: "SET_CURRENT_PAGE",
      channel,
      pageId: id,
      requestTimestamp: Date.now(),
    });
  };

  return <div id="navigation-controller"></div>;
};

export default connect(
  ({ formatic: { apiKey, dataForm, currentPage, channel, pageFlow } }) => ({
    apiKey,
    currentPage,
    channel,
    form: dataForm,
    pageFlow,
  })
)(NavigationController);
